import { useLoadingContext } from '@features/contexts/LoadingProvider';

/**
 * @returns An object containing an `allLoading` property which defines
 * whether or not anything in the app is currently loading.
 */
export const useLoading = () => {
    const { loading } = useLoadingContext();
    return {
        anyLoading: loading,
    };
};
